import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { NgStyle } from "@angular/common";

@Component({
  selector: "app-text",
  templateUrl: "./text.component.html",
  styleUrls: ["./text.component.scss"],
  imports: [NgStyle],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class TextComponent {
  @Input() color = "dark-shade";

  @Input() weight = "400";

  @Input() size = "";
}
